export default "__VITE_ASSET__DmnlK4dY__"